import { useRef, useState } from 'react'

import { MenuPopUp } from './menu-pop-up.component'
import { MenuIcon, MenuIconButton, MenuWrapper } from './menu-burger.styled'
import { JOURNEY_PAGE_TEMPLATE_ID } from 'src/templates/constants'

type MenuBurgerProps = {
  variant?: 'default' | JOURNEY_PAGE_TEMPLATE_ID
  backgroundColor?: string
  textColor?: string
  topOffset?: number
}

export const MenuBurger = ({
  variant = 'default',
  backgroundColor,
  textColor,
  topOffset = 0,
}: MenuBurgerProps) => {
  const [toggle, setToggle] = useState(false)
  const anchorEl = useRef<HTMLButtonElement | null>(null)

  const handleToggle = () => {
    setToggle(!toggle)
  }

  return (
    <MenuWrapper id="index__components-menu-burger__div__l15" topOffset={topOffset}>
      <MenuIconButton
        id="index__components-menu-burger__menuiconbutton__l16"
        ref={anchorEl}
        onClick={handleToggle}
        variant={variant}
        backgroundColor={backgroundColor}
        textColor={textColor}
      >
        <MenuIcon id="index__components-menu-burger__menuicon__l17" variant={variant} />
      </MenuIconButton>
      <MenuPopUp anchorEl={anchorEl.current} open={toggle} handleClose={handleToggle} />
    </MenuWrapper>
  )
}
